import React from 'react';
import NumberFormat from 'react-number-format';

export const ThichHop = (props) => {
    const ShowEdit = () => {
        props.showEditThongTin();
    }
    return (
        <div className="thong-tin">
            {
                props.thongTin.tenxa ? <table className="table table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th colSpan="2"> Bản đồ thích nghi
                            {
                                    props.admin ? <button type="button" className="btn btn-primary btn-sm suathongtin" onClick={ShowEdit}><i className='fas fa-edit'></i></button> : ''
                                }
                            </th>
                        </tr>
                        <tr>
                            <th className="col-name">Tên</th>
                            <th>Thông tin</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-name">Huyện</td>
                            <td>Chư Pưh</td>
                        </tr>
                        <tr>
                            <td className="col-name">Xã</td>
                            <td>{props.thongTin?.tenxa}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Diện tích(ha)</td>
                            <td>
                                <NumberFormat value={props.thongTin?.dt_ha} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-name">Mã thích hợp</td>
                            <td>{props.thongTin?.thichnghi_}</td>
                        </tr>

                        
                        <tr>
                            <td className="col-name">Hồ tiêu</td>
                            <td>{props.thongTin?.thtieu}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Caffe</td>
                            <td>{props.thongTin?.thcaffe}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Cao su</td>
                            <td>{props.thongTin?.thcaosu}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Điều</td>
                            <td>{props.thongTin?.thdieu}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Lúa</td>
                            <td>{props.thongTin?.thlua}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Ngô</td>
                            <td>{props.thongTin?.thngo}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Sắn</td>
                            <td>{props.thongTin?.thsan}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Khoai</td>
                            <td>{props.thongTin?.thkhoai}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Rau</td>
                            <td>{props.thongTin?.thrau}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Dược liệu</td>
                            <td>{props.thongTin?.thduoclieu}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Bơ</td>
                            <td>{props.thongTin?.thbo}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Sầu riêng</td>
                            <td>{props.thongTin?.thsaurieng}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Bí</td>
                            <td>{props.thongTin?.thbi}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Lạc</td>
                            <td>{props.thongTin?.thlac}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Hoa</td>
                            <td>{props.thongTin?.thhoa}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Cam</td>
                            <td>{props.thongTin?.thcam}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Bưởi</td>
                            <td>{props.thongTin?.thbuoi}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Chanh dây</td>
                            <td>{props.thongTin?.thchanhday}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Nhãn</td>
                            <td>{props.thongTin?.thnhan}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Mít</td>
                            <td>{props.thongTin?.thmit}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Xoài</td>
                            <td>{props.thongTin?.thxoai}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Na</td>
                            <td>{props.thongTin?.thna}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Chuối</td>
                            <td>{props.thongTin?.thchuoi}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Dâu tằm</td>
                            <td>{props.thongTin?.thdautam}</td>
                        </tr>
                        <tr>
                            <td className="col-name">măng tây</td>
                            <td>{props.thongTin?.thmangtay}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Dứa</td>
                            <td>{props.thongTin?.thdua}</td>
                        </tr>
                       
                    </tbody>
                </table> : <h5 className="text-center">Không có thông tin</h5>
            }
        </div>
    )
};